import { FaChartLine, FaSearch, FaUsers, FaMoneyBillWave } from "react-icons/fa";

export default function SectionSeoResults() {
    const results = [
        {
            text: "Increased organic traffic across different types of businesses through improved keyword targeting and content optimization",
            icon: <FaChartLine className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            text: "Improved rankings from lower search positions to page one for high-intent and competitive keywords across multiple industries",
            icon: <FaSearch className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            text: "Generated more qualified organic leads and sales by optimizing landing pages and search intent alignment",
            icon: <FaUsers className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        },
        {
            text: "Reduced dependency on paid advertising by building consistent organic visibility across search engines",
            icon: <FaMoneyBillWave className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
        }
    ];

    return (
        <div className="SectionSeoResults py-[60px] md:py-[100px] bg-[#f9f9f9]">
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    SEO Results and Case Studies
                </h2>

                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[750px] mx-auto leading-[28px]">
                    Real results from SEO services campaigns.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 w-[90%] md:w-[80%] mx-auto">
                {results.map((item, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center text-center bg-white p-8 rounded-lg shadow-lg transition transform hover:-translate-y-2 hover:scale-105 duration-300"
                    >
                        <div className="mb-5">{item.icon}</div>

                        <p className="text-gray-700 text-sm md:text-base leading-[26px]">
                            {item.text}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}